export const companyConstants = {
    GETALL_REQUEST: 'COMPANY_GETALL_REQUEST',
    GETALL_SUCCESS: 'COMPANY_GETALL_SUCCESS',
    GETALL_FAILURE: 'COMPANY_GETALL_FAILURE',

    DELETE_REQUEST: 'COMPANY_DELETE_REQUEST',
    DELETE_SUCCESS: 'COMPANY_DELETE_SUCCESS',
    DELETE_FAILURE: 'COMPANY_DELETE_FAILURE'
};
